import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arvr-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit {
  contents = [
    '<img src="../../../assets/JAIPUR.png" alt="" style="width: 130px;margin-top: 5px;margin-bottom: 9px;z-index:2;">',
  ];

  constructor() {}

  ngOnInit(): void {
    let mbLogos = document.getElementById('mb-logos');
    // let i = 0;
    // mbLogos.innerHTML = this.contents[i];
    mbLogos.innerHTML = this.contents[0];
    // setInterval(() => {
    //   i += 1;
    //   mbLogos.innerHTML = this.contents[i % 2];
    // }, 2000);
  }
}
